import { FC } from 'react'
import { ICalculatorResult } from './types'
import style from './style.m.less'

interface IResultBlock {
    result: ICalculatorResult
}

const ResultBlock: FC<IResultBlock> = ({ result }) => {
    return (
        <div className={style.result}>
            <span className={style.resultHead}>Общая стоимость составляет:</span>
            <ul className={style.resultList}>
                <li className={style.resultLabel}>
                    Стоимость с НДС:
                    <span className={style.resultValue}>{result.priceFee}</span>
                </li>
                <li className={style.resultLabel}>
                    НДС:
                    <span className={style.resultValue}>{result.fee}</span>
                </li>
                <li className={style.resultLabel}>
                    Стоимость без НДС:
                    <span className={style.resultValue}>{result.price}</span>
                </li>
            </ul>
        </div>
    )
}

export default ResultBlock
